import { render, staticRenderFns } from "./NuevaReferenciaLaboralDialogComponent.vue?vue&type=template&id=ee2c0e9a&scoped=true"
import script from "./NuevaReferenciaLaboralDialogComponent.vue?vue&type=script&lang=js"
export * from "./NuevaReferenciaLaboralDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./NuevaReferenciaLaboralDialogComponent.vue?vue&type=style&index=0&id=ee2c0e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2c0e9a",
  null
  
)

export default component.exports